export const ShareAppModalVersionA = () => null
